import { PublicDashboardComponent } from './public-dashboard-component';

export function PublicDashboardFactory() {
    return <PublicDashboardComponent />;
}
